export default "/images/b451afde272570841e921c62bdf50cf9.avif";